<!-- <div *ngIf="complete">
    <h5 class="text-start text-primary fw-bold ps-2 ms-1 mt-2 mb-4">Congratulations! You have now completed your application to open a demat and trading account!</h5>
    <div class="ps-2">
        <p><strong>What's Next?</strong></p>    
        <p>You application's scrutiny will take a maximum of 3 working days and you will be informed via mail on the successful activation of your account or if a discrepancy needs to be cleared.</p>
        <p>In the mean time, you can explore the wide range of offerings provided by Axis Direct by visiting our website, or know better about our products by visiting our <a href="https://simplehai.axisdirect.in/faqs" target="_blank">FAQs section</a></p>

    </div>
</div> -->

<div class="container mt-md-5 mt-2">
    <div class="row">
        <div class="col-12 text-end" *ngIf="load">
            <button class="btn btn-white border-primary text-primary px-md-3 px-1 small me-3" *ngIf="pisPdf" (click)="downloadAOF(false)">Download PIS</button>
            <button class="btn btn-white border-primary text-primary px-md-3 px-1 small" (click)="downloadAOF(true)">Download AOF</button>
        </div>
        <div class="col-md-12 col-lg-12 col-12 text-center">
            <img src="./assets/images/Success 1.png" class="img-fluid" alt="" srcset="">
        </div>
        <div class="col-lg-12 text-center">
            <p class="h3 text-primary">Woah!</p>
        </div>
        <div class="col-lg-12 text-center">
            <p class="h6 text-primary">Thank you for choosing SBI Securities</p>
        </div>
        <div class="col-lg-12 text-center d-flex justify-content-center">
            <div class="row mx-0 border w-md-50">
                <div class="col-md-12 p-3">
                    <p>Your Application Number</p>
                    <p class="h4 text-gradient">{{applicationNumber}}</p>
                </div>
            </div>
        </div>
        <div class="col-lg-12 mt-3 text-center">
            <p>{{verification}}</p>
        </div>
        <div class="col-lg-12" *ngIf="NRO !=='Y'">
            <div class="row mx-0">
                <div class="col-12 fw-bold text-center">
                    Thank You for Your NRI Demat & Trading Account Application!
                </div>
                <div class="col-12">
                    Thank you for submitting your NRI Demat & Trading account application. We appreciate your time
                    and effort in providing all the necessary information.
                    <p class="mt-2">
                        Next Steps:
                    </p>
                    <p>
                        <strong>1. Document Verification: </strong> We will review the documents you uploaded. You will receive a
                        confirmation email once all documents are checked and verified.
                    </p>
                    <p>
                        <strong>2. Courier Hard Copies:</strong>   Please follow the instructions in the confirmation email for couriering
                        signed hard copies of the Account Opening application along with your self-attested and
                        notarized KYC documents.
                    <p>
                        If you have any questions or need further assistance, feel free to contact our support team at
                        <a href="mailto:NRIDESK.SSL@sbicapsec.com">NRIDESK.SSL&#64;sbicapsec.com</a> / <a href="tel:+91 2268567464">+91 2268567464.</a>
                        We are available from 9: 30 AM to 6:30 PM IST (Monday to Saturday only) except 2<sup>nd</sup> & 4<sup>th</sup> Saturdays.
                    </p>
                    <p>
                        Thank you for choosing us for your investment and trading needs. We look forward to serving you!
                    </p>
                    <!-- <p class="mb-1">
                        Best regards,
                    </p>
                    <p>
                        <strong>SBI Securities Limited</strong>
                    </p> -->
                </div>
            </div>
        </div>
        <div class="col-lg-12" *ngIf="NRO ==='Y'">
            <div class="row mx-0">
                <div class="col-12 fw-bold text-center">
                    Your application for an NRO Demat & Trading Account has been successfully submitted. 
                </div>
                <div class="col-12">
                  <p class='mt-2' >✅ If all details are found in order, your account will be activated within 3 working days.. </p>
                  <p class="mt-2"> ⚠️ In case of any discrepancies in the information/documents provided, you will receive a notification for correction. </p>
                    <p class="mt-2">
                        Next Steps:
                    </p>
                    <!-- <p>
                        <strong>1. Document Verification: </strong> We will review the documents you uploaded. You will receive a
                        confirmation email once all documents are checked and verified.
                    </p> -->
                    <!-- <p>
                        <strong>2. Courier Hard Copies:</strong>   Please follow the instructions in the confirmation email for couriering
                        signed hard copies of the Account Opening application along with your self-attested and
                        notarized KYC documents.
                    </p> -->
                    <p>
                        Download the SBI Securities Mobile App and get ready to start your trading journey. 
                        If you have any questions or need further assistance, feel free to contact our support team at
                        <a href="mailto:NRIDESK.SSL@sbicapsec.com">NRIDESK.SSL&#64;sbicapsec.com</a> / <a href="tel:+91 2268567464">+91 2268567464.</a>
                        We are available from 9: 30 AM to 6:30 PM IST (Monday to Saturday only) except 2<sup>nd</sup> & 4<sup>th</sup> Saturdays.
                    </p>
                    <p>
                        We’re excited to welcome you to SBI Securities and look forward to being your trusted partner in investments. 
                    </p>
                    <!-- <p class="mb-1">
                        Best regards,
                    </p>
                    <p>
                        <strong>SBI Securities Limited</strong>
                    </p> -->
                </div>
            </div>
        </div>
        <!-- <div class="col-lg-12 my-4 text-center">
            <div class="row">
                <div class="col-md-12">
                    <img src="./assets/images/success2.png" class="img-fluid" alt="">
                </div>
                <div class="col-md-3 text-center">
                    <p class="fw-bold">Initiated</p>
                    <p class="small">Your Application Is Initiated</p>
                </div>
                <div class="col-md-3 text-center ">
                    <p class="fw-bold">Form Received</p>
                    <p class="small">Your Application Has Been Received Successfully</p>
                </div>
                <div class="col-md-3 text-center">
                    <p class="fw-bold">Application Completed</p>
                    <p class="small">Your Application Has Successfully Completed</p>
                </div>
                <div class="col-md-3 text-center">
                    <p class="fw-bold text-success">Verification</p>
                    <p class="small">Your Application Sent To Verification Successfully</p>
                </div>
            </div>
        </div> -->
    </div>
</div>

<div class="row w-100">
    <div class="my-4 col-12 text-end">
        <button class="btn btn-primary  px-4" (click)="stageValidate()">Close</button>
    </div>
</div>



<div class="modal fade" id="appstatus" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5" id="exampleModalLabel">Thank you for choosing SBI Securities</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
            You Can Download your AOF {{pisPdf ? 'and PIS' : ''}} by clicking the below link.    
        </div>
        <div class="modal-footer">
          <button *ngIf="pisPdf" type="button" class="btn btn-primary me-3" (click)="downloadAOF(false)">Download PIS</button>
          <button type="button" class="btn btn-primary" (click)="downloadAOF(true)">Download AOF</button>
        </div>
      </div>
    </div>
  </div>
  <ngx-ui-loader></ngx-ui-loader>
  <app-error-modal #errorComp></app-error-modal>